<div class="contact-popover" (mouseenter)="hoverOpen()" (mouseleave)="scheduleClose()">
  <!-- The nav item; the href is for a middle click / new tab and for crawlers -->
  <a class="cp-link"
     [attr.href]="URLS.contactUs"
     [class.menu-open]="open"
     aria-haspopup="dialog"
     [attr.aria-expanded]="open"
     (click)="toggle($event)">
    <span>Contact Us</span>
  </a>

  <!-- The popover: a macOS menu bar panel under the item, the form in it -->
  <div class="cp-panel" *ngIf="open" role="dialog" aria-label="Contact Us">
    <app-contact-form [form]="form" source="Nav Popover" (sentChange)="sent = $event" (done)="closeDropdown()"></app-contact-form>
  </div>
</div>
